// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.invemory.com/api',
  webAppBaseUrl: 'https://dev.invemory.com',
  googleClientId: '570007661389-sgvmo0gu2dblgadf037kkc75qc186u31.apps.googleusercontent.com',
  appVersion: '1.2.3-build.40',
  monetizationMode: 'web-checkout' as const,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
